import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/services/user.service';
import { environment } from '../../shared/config/app-config';
import { FormSessionCanDeactivate } from '../../shared';

@Component({
  selector: 'app-postopp',
  templateUrl: './postopp.component.html',
  styleUrls: ['./postopp.component.css']
})
export class PostoppComponent extends FormSessionCanDeactivate {

  constructor(
    private userService: UserService
  ) {
    super();
  }
  public dateformat = environment.dateFormat;
	public bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue',showWeekNumbers: false,dateInputFormat: this.dateformat});
  ngOnInit() {
  }
  date:any ={
    'dos':"04/09/2018",
    'planned':"04/12/2018",
    'actual':"04/13/2018",
    'agencyplanned':"04/17/2018",
    'agencyactual':"04/17/2018",
    'plannedlos':"5",
    'actuallos':"4",
    'dischargeplanned':"SNF",
    'facilityplanned':"Danube Senior Living", 
  }
  dateValueChange(event)
 {     
  if (event.keyCode != 8) {
    if(event.target.value.length == 2 || event.target.value.length == 5){
       var thisVal = event.target.value;
       thisVal += '/';
       event.target.value = thisVal;
     }
   }
   
 }
  
}

